import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExportNotification = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.405 1.9225L12.3625 0.6625C12.16 0.4075 11.8525 0.25 11.5 0.25H2.5C2.1475 0.25 1.84 0.4075 1.63 0.6625L0.595 1.9225C0.3775 2.1775 0.25 2.515 0.25 2.875V12.25C0.25 13.075 0.925 13.75 1.75 13.75H12.25C13.075 13.75 13.75 13.075 13.75 12.25V2.875C13.75 2.515 13.6225 2.1775 13.405 1.9225ZM2.68 1.75H11.32L11.9275 2.4775H2.08L2.68 1.75ZM1.75 12.25V4H12.25V12.25H1.75ZM8.0875 5.5H5.9125V7.75H4L7 10.75L10 7.75H8.0875V5.5Z",
		fill: "#7B7BFF"
	})
});
export { SvgExportNotification as ReactComponent };
